import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';
//Data de errores Atentus
import atErrorCodes from  '../../../../data/at_error_codes';


import moment from 'moment'
import 'moment/locale/es'  
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
moment.locale('es')


class ErrorsEventsObjective extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.params.props.obj,
            prevObjectiveId: this.props.params.props.obj,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,           
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            extendEl: null,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            listObjectives: this.props.params.props.listObjectives,
            nameNodo: "Global",
            nodo: 0
            //listNodo: []
        }  
    }
    

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        /*if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else */if (props.params.state.period !== state.time) {
            return {                
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.state.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                //statePeriod: props.params.statePeriod,
                //isStatePeriod: props.params.isStatePeriod
            }
        } /*else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }*/
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        /*if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }*/
        if ((prevProps.params.state.period !== this.state.time) || (prevState.nodo !== this.state.nodo)) {
            this.getDataFromAPI();
        }

    }
    handleShowExtend = event => {
        this.setState({
             extendEl: event.currentTarget
         });
     };
 
     handleCloseExtend = event => {
         this.setState({
             extendEl: null
         });
     };
     handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = parseInt(event.currentTarget.id)
        if (this.state.node !== newNode) {
            this.setState({
                nodo: newNode,                
                extendEl: null,
                nameNodo: nameNodo,  
                isLoading: true             
            })
        }
    }

  handleShowErrorDescription = event => {

  }
    

    getDataFromAPI = (objectiveId) => {
      
        const { obj } = this.props.params.props
        const { listObjectives } = this.props.params.props
        const { period, statePeriod } = this.props.params.state
        const { nodo } = this.state
        let listObjective = []
        Object.keys(listObjectives).map(key => {            
            Object.keys(listObjectives[key]).map(key2 => {
                if (listObjectives[key][key2].objetivo_id == obj){
                    listObjective.push(listObjectives[key][key2]);
                }
            })
        })        
        let sla_rendimiento_ok = parseInt(listObjective[0].sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(listObjective[0].sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(listObjective[0].sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(listObjective[0].sla_disponibilidad_error)
        let nodos = listObjective[0].Nodos
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (nodo !== 0) {  
            fetch(api_host+`/reporte/online/indicadores/getEventosNodoErroresFrecuentes/?objetivoId=${obj}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&t=${period}&nodoId=${nodo}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino, nodos)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            fetch(api_host+`/reporte/online/indicadores/getEventosObjetivoErroresFrecuentes/?objetivoId=${obj}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&t=${period}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino, nodos)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino, nodos) => {
           
            let arrayRows = []            
            let evento = externalData.Objetivo.Eventos
            this.props.params.onFirstInfo(externalData.Objetivo.Mediciones)
            if (evento.length > 0) {
                Object.keys(evento).map((key)=> {
                    let rows = {}                   
                    /*let fecha = new Date(evento[key]['fecha_min'])
                    rows['fecha'] = fecha.toLocaleDateString("en-GB",{ year: "numeric",month: "2-digit",day: "2-digit",}).replace('/', '-').replace('/', '-').substring(0,8) 
                    +" "+
                    fecha.toLocaleTimeString("en-GB",{ hour: "2-digit", minute: "2-digit", second:"2-digit" })*/
                    rows['paso'] = evento[key]['id'][1]['paso_nombre']
                    rows['cantidad'] = evento[key]['cantidad']
                    rows['error'] = evento[key]['id'][0]
                    rows['error_name'] = evento[key]['eventos'][0]['nombre']
                    /*if(evento[key]['respuesta'] >= sla_rendimiento_error){
                        rows['customColumnStyle'] = { color: "red" }
                    } else {
                        rows['customColumnStyle'] = { color: "green" }
                    }*/                    
                    arrayRows.push(rows)        
                })  
    
                this.setState({
                    rows : arrayRows,                    
                    isLoading: false,                    
                    dataError: false,
                    listNodo: nodos
                });
            } else {
                this.setState({                    
                    isLoading: false,
                    rows: null,                   
                    dataError: false,
                    listNodo: nodos
                });
            }
    }
    render() {
        const { dataError, isLoading, rows, extendEl, nameNodo, listNodo } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };

        const showExtendEl = Boolean(extendEl);    
        const t = (this.props && this.props.t) ? this.props.t : (s => s)   
  
        if (!dataError) {
            return (
                <div style={{backgroundColor:"white"}}>
                     { isLoading ?
                       
                        <div style={{backgroundColor:"white"}}>
                        <Portlet style={{backgroundColor:"white", border: "0px" }}>
                           <div style={{marginTop:"2%", backgroundColor:"white"}}>
                               <div style={{float:"left", marginLeft:"5%",  marginBottom:"2%", backgroundColor:"white"}}>
                                   <PortletLabel
                                       /*  icon={<DevicesIcon />} */
                                       variant="h6"
                                       title={t('modal.objective.frequent-errors.titler')}
                                   />
                               </div>
                               <div style={{float:"right", backgroundColor:"white"}} >
                                   <Button
                                       style={{color:"#fff"}}
                                       variant="text"
                                       onClick={this.handleShowExtend}
                                   
                                   >
                                   </Button>
                               </div>
                               
                           </div>
                       </Portlet>
                       </div>
                    :
                            <div style={{backgroundColor:"white"}}>
                            <Portlet style={{backgroundColor:"white", border: "0px" }}>
                               <div style={{marginTop:"2%", backgroundColor:"white"}}>
                               <div style={{float:"left", marginLeft:"5%",  backgroundColor:"white"}}>
                                       <PortletLabel
                                           /*  icon={<DevicesIcon />} */
                                           variant="h6"
                                           title={t('modal.objective.frequent-errors.title')}
                                       />
                                   </div>
                                   <div style={{float:"right"}}>
                                       <Button
                                           variant="text"
                                           onClick={this.handleShowExtend}
                                       
                                       >
                                           {nameNodo} <ArrowRightIcon />
                                       </Button>
                                   </div>
                                   
                               </div>
                           </Portlet>
                           <Popover
                               anchorEl={extendEl}
                               anchorOrigin={{
                                   vertical: 'bottom',
                                   horizontal: 'center'
                               }}
                               onClose={this.handleCloseExtend}
                               open={showExtendEl}
                               transformOrigin={{
                                   vertical: 'top',
                                   horizontal: 'center'
                               }}>
                               <div >                   
                                   <List component="div">
                                       {Object.values(listNodo).map(i => (                                           
                                           <ListItem                                              
                                               component="div"
                                           >
                                           <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                       </ListItem>))}
                                   </List>                                       
                               </div>
                           </Popover> 
                        </div>
                    }                    
                    <FormattedChart rows={rows} isLoading={isLoading} style={style} styleHidden={styleHidden} t={t}/>                    
                </div>
            ) 
        }
        else if (dataError) {
            return (<p>{t('modal.objective.render.no-data')}</p>)
        }
        else return (<p>{t('modal.objective.render.error')}</p >)

    }
}

function FormattedChart(props) {
    return (
        <div >
            <div style={props.styleHidden}>
            <AtCircularProgress />
            </div>
            <div style={props.style}>
                
                { props.rows == null  ? 

                    <Table  aria-label="spanning table" >
                    <TableHead  style={{ backgroundColor:"#ffffff"}}>
                        <TableRow>
                            <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{props.t('modal.objective.frequent-errors.table.error-type')}</TableCell>
                            <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{props.t('modal.objective.frequent-errors.table.quantity')}</TableCell>
                            <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{props.t('modal.objective.frequent-errors.table.step')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ backgroundColor:"#ffffff"}}>
                        <TableCell colspan="3">{props.t('modal.objective.frequent-errors.table.no-errors')}</TableCell>
                    </TableBody>
                    </Table>
                    
                   
                :   <Table  aria-label="spanning table" >
                    <TableHead style={{ backgroundColor:"#ffffff"}}>
                        <TableRow>
                            <TableCell colspan="2" style={{color:"#6b6b6b", textAlign: "center"}}>{props.t('modal.objective.frequent-errors.table.error-type')}</TableCell>
                            <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{props.t('modal.objective.frequent-errors.table.quantity')}</TableCell>
                            <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{props.t('modal.objective.frequent-errors.table.step')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.rows.map( (row, index) => {

                         
                          //Obtiene la descripción del error        
                          const errorCode = atErrorCodes.filter( id => id.nombre === row.error_name );
                        

                        return (
                            /* Efecto ODD / EVEN */
                        <TableRow style= { index % 2 === 0 ? { backgroundColor : "#ebebeb", border:'0px' } : 
                            { backgroundColor : "#ffffff", border:'0px' }} > 
        
                                <TableCell style={{color:"#FF6666", border:'0px', fontWeight: "bold", textAlign: "center"}}>
                                    <Tooltip title={errorCode[0]['descripcion']} arrow="true" leaveDelay={200}>
                                    <WarningRoundedIcon color="white"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell style={{border:'0px', fontWeight: "bold", textAlign: "center"}}>{row.error_name}</TableCell>
                                <TableCell style={{fontWeight: "bold", fontSize: 15, color: '#FF9933', border:'0px', textAlign: "center"}}>{row.cantidad}</TableCell>
                                <TableCell style={{border:'0px', textAlign: "center"}}>{row.paso}</TableCell>
                            </TableRow>)
                        })}                        
                    </TableBody>
                </Table>}                
            </div>
        </div>
        )
}


export default compose(withRouter, withTranslation())(ErrorsEventsObjective);